// REACT & Libraries
import { useEffect } from "react";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";

// Role Guard
import RoleGuard from "../../RoleGuard";

// Components
import JobLevelContainer from "../../../Components/MasterData/JobLevel";

const EmployeeStatus = () => {
  const { user } = useAppSelector((state) => state.auth);
  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];
  useEffect(() => {
    document.title = "Job Level / Rank Master Data";
  }, []);

  return (
    <>
      {/* RoleGuard ensures only allowed roles can view the page */}
      <RoleGuard
        userRoles={currentUserRoles}
        allowedRoles={["admin", "data-master"]}
      />

      {/* Main content */}
      <JobLevelContainer />
    </>
  );
};

export default EmployeeStatus;
